import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";

import usePagination from "../../../../hooks/usePagination";
import { FilterAutocomplete } from "../../../../components/ui";
import { FAILED_COLUMNS } from "./constants";
import { complianceSearchActions } from "../../../../reducers/complianceSearch";
import { useComplianceSearchContext } from "../../../../context";
import { Table } from "../../../../components/ui";
import { COMPLIANCE_API_URLS, ComplianceAPI } from "../../../../api/compliance";
import { appendCommaSeparatedValuesToQuery, TitleUpdated } from "../../utils";
import { SectionTitle } from "../../styledComponents";

const HeliosFailedSearch: React.FC = () => {
  const pagination = usePagination(100);
  const dispatch = useDispatch();

  const { tabsTablesSearchState, setTabsTablesSearchState } = useComplianceSearchContext();
  const { names, compliance_entries_id } =
    tabsTablesSearchState.fundedAccountQuickSearchTab.heliosFailedSearchTable.search;

  const {
    loading,
    data: { updated, results },
  } = useSelector((state) => state.complianceSearch.watchlistFailed);

  const { isError, error } = useQuery({
    enabled: names?.length >= 2 || compliance_entries_id?.length > 0,
    queryKey: [
      COMPLIANCE_API_URLS.getFailed,
      names,
      compliance_entries_id,
      pagination.page,
      pagination.limit,
    ],
    async queryFn({ signal }) {
      const query = new URLSearchParams();
      query.append("limit", pagination.limit.toString());
      query.append("page", pagination.page.toString());

      names && appendCommaSeparatedValuesToQuery(names, query, "names");
      compliance_entries_id &&
        appendCommaSeparatedValuesToQuery(compliance_entries_id, query, "compliance_entries_id");

      dispatch(complianceSearchActions.fetchWatchlistFailedRequest());
      const response = await ComplianceAPI.getWatchlistFailedRequest(query.toString(), signal);
      pagination.setCount(response.data.results.count);
      dispatch(complianceSearchActions.fetchWatchlistFailedSuccess(response.data));
      return response;
    },
  });

  useEffect(() => {
    if (isError && error) {
      console.error("Error fetching passes", error);
      dispatch(complianceSearchActions.fetchWatchlistFailedFailed());
    }
  }, [isError, error]);

  useEffect(() => {
    pagination.setPage(0);
  }, [names, pagination.limit]);

  return (
    <SectionTitle title="Failed">
      <FilterAutocomplete
        search={{
          compliance_entries_id,
          names,
        }}
        setSearch={(values) => {
          setTabsTablesSearchState({
            ...tabsTablesSearchState,
            fundedAccountQuickSearchTab: {
              ...tabsTablesSearchState.fundedAccountQuickSearchTab,
              heliosFailedSearchTable: {
                search: {
                  names: values.names,
                  compliance_entries_id: values.compliance_entries_id,
                },
              },
            },
          });
        }}
        filters={{
          EntriesId: "compliance_entries_id",
          Name: "names",
        }}
      />

      <Table
        columns={FAILED_COLUMNS}
        data={results.rows}
        loading={loading}
        pagination={pagination}
        extractKey={(row) => row.id}
        title={<TitleUpdated value={updated?.date} />}
        csv_table_name="Funded account quick search - Failed"
      />
    </SectionTitle>
  );
};

export default HeliosFailedSearch;
